import { gql } from '@apollo/client'
import { AddressFragment } from './address.fragments'
import { processEnv } from 'components/configuration/environmentVariables'

export const FirmFragments = {
    subscriptionInfoFragment: gql`
        fragment subscriptionInfoFragment on SubscriptionInfo {
            salesforceId
            expiration
            maxUsers
            maxReviewers
        }
    `,
    supportContactUserFragment: gql`
        fragment supportContactUserFragment on User {
            id
            email
            profileInfo {
                firstName
                lastName
            }
        }
    `,
    designatedAccountAdminUserFragment: gql`
        fragment designatedAccountAdminUserFragment on User {
            id
            email
            profileInfo {
                firstName
                lastName
            }
        }
    `,
    firmProfileInfoFragment: gql`
        fragment firmProfileInfoFragment on FirmProfileInfo {
            address {
                ...addressFragment
            }
            contactInfo {
                email
                firstName
                lastName
            }
            publicPhone
            website
        }
    `,
    firmUsersFragment: gql`
        fragment firmUsersFragment on User {
            id
            status
            email
            role
            userType
            isDesignatedAccountAdminUser
            isBestPracticeGroupEnabled
            isOnboarder
            profileInfo {
                firstName
                lastName
                professionalRole
                professionalDiscipline
                imageUrl
                phone
                address {
                    ...addressFragment
                }
            }
        }
        ${AddressFragment}
    `,

    firmProjectGroupFragment: gql`
        fragment firmProjectGroupFragment on ProjectGroup {
            name
            id
        }
    `,
    associationModifierListsFragment: gql`
        fragment associationModifierListsFragment on AssociationModifierList {
            name
            id
            associationModifiers {
                id
                name
            }
        }
    `,
    firmProjectPhasesFragment: gql`
        fragment firmProjectPhasesFragment on ProjectPhase {
            id
            loD
            name
        }
    `,
    firmProfessionalDisciplinesFragment: gql`
        fragment firmProfessionalDisciplinesFragment on ProfessionalDiscipline {
            id
            name
            roles
        }
    `,
}
export const AccountFirmFragment = gql`
    fragment accountFirmFragment on Firm {
        id
        name
        accountType
        profileInfo {
            ...firmProfileInfoFragment
        }
        subscriptionInfo {
            ...subscriptionInfoFragment
        }
        status
        displayName
        areBestPracticesEnabled
        supportContactUser {
            ...supportContactUserFragment
        }
        designatedAccountAdminUser {
            ...designatedAccountAdminUserFragment
        }
        isReseller
        resellerFirmId
        hideIndustryAnalytics
        firmsHideIndustryAnalytics
        isSpecTextLibraryVisible
        ${
            processEnv.REACT_APP_ShowMFACheckbox === '1'
                ? 'isMFARequiredForLogins isMFARequiredForLoginsEnabledDate'
                : ''
        }
        isApiSubscriptionEnabled
        apiSubscriptionKey
        dataPrivacySettings {
            includeInResearchMap
            isGlobalDataOptOutEnabled
        }
    }
    ${FirmFragments.firmProfileInfoFragment}
    ${FirmFragments.subscriptionInfoFragment}
    ${FirmFragments.supportContactUserFragment}
    ${FirmFragments.designatedAccountAdminUserFragment}
    ${AddressFragment}
`
